const CircleLoader = ({ reverseColor = false }) => {
  return (
    <div className="dots">
      {Array.from({ length: 15 }, (_, index) => (
        <span
          key={index}
          style={
            {
              "--i": index + 1,
              background: reverseColor
                ? "var(--bg-light)"
                : "var(--primary-clr)",
            } as React.CSSProperties
          }
        ></span>
      ))}
    </div>
  );
};

export default CircleLoader;
